<template>
    <div class="hero_wrapper Custom-Slider">

        <div class="row">
            <div class="container">
                <div class="row">
                    <div class="col-md-8">
                        <div class="row">
                            <div class="col-md-12">
                                <h1 class="Custom-Slider-title">Bienvenidos a <span id="text_rotating">Hotel CEO Group</span></h1>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <h2 class="Custom-Slider-rating">
                                    <ul>
                                        <li><i class="fa fa-star-o"></i></li>
                                        <li><i class="fa fa-star-o"></i></li>
                                        <li><i class="fa fa-star-o"></i></li>
                                        <!--<li><i class="fa fa-star-o"></i></li>
                                        <li><i class="fa fa-star-o"></i></li>-->
                                        <li class="Custom-Slider-rating-text">Su mejor opción de hospedaje en Campeche</li>
                                    </ul>
                                </h2>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <h4 class="Custom-Slider-list">
                                    <ul>
                                        <li><i class="fa fa-check-square-o"></i> Habitaciones modernas y cómodas</li>
                                        <li><i class="fa fa-check-square-o"></i> Excelente ubicación cercano al malecón de la Ciudad</li>
                                        <li><i class="fa fa-check-square-o"></i> Estacionamiento y alberca al aire libre</li>
                                    </ul>
                                </h4>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <div class="Custom-Slider-box">
                                    <div class="row Custom-Slider-box-item">
                                        <div class="col-md-2 Custom-Slider-box-item-icon">
                                            <i class="fa fa-wifi"></i>
                                        </div>
                                        <div class="col-md-8 Custom-Slider-box-item-text" style="padding-top: 10px;">
                                            <span class="uppercase">Wi-Fi</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="Custom-Slider-box">
                                    <div class="row Custom-Slider-box-item">
                                        <div class="col-md-2 Custom-Slider-box-item-icon">
                                            <i class="fa fa-cutlery"></i>
                                        </div>
                                        <div class="col-md-8 Custom-Slider-box-item-text" style="padding-top: 10px;">
                                            <span class="uppercase">Comedor</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="Custom-Slider-box">
                                    <div class="row Custom-Slider-box-item">
                                        <div class="col-md-2 Custom-Slider-box-item-icon">
                                            <i class="fa fa-car"></i>
                                        </div>
                                        <div class="col-md-8 Custom-Slider-box-item-text" style="padding-top: 10px;">
                                            <span class="uppercase">Estacionamiento</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 Custom-Slider-form">
                        <book-online></book-online>
                    </div>
                </div>
            </div>
        </div>



    </div>
</template>

<script>
    let bookOnline = require('../bookOnlineForm/book.vue');
    export default{
        data : function()
        {
            return {
                header_services : null
            };
        },
        components : {
            'book-online' : bookOnline
        },
        beforeDestroy : function(){
            this.unsubscribe();
        },
        created : function(){
            var self = this;
            this.unsubscribe  = this.$store.subscribe((mutation,state) => {
                self.$language = self.$store.state.language;
            });
            setTimeout(function(){
                $('.Custom-Slider-title').css('opacity','1').addClass('animated slideInUp');
            }, 1000);
            setTimeout(function(){
                var initial = 200;
                $('.Custom-Slider-rating').find('ul').find('li').each(function(i, item){
                    setTimeout(function(){
                        $(item).css('opacity', 1).addClass('animated fadeInUp');
                    }, initial );
                    initial = initial+200;
                });
            }, 1500);
            setTimeout(function(){
                var initial = 200;
                $('.Custom-Slider-list').find('ul').find('li').each(function(i, item){
                    setTimeout(function(){
                        $(item).css('opacity', 1).addClass('animated slideInUp');
                    }, initial );
                    initial = initial+200;
                });
            }, 3000);
            setTimeout(function(){
                $('.Custom-Slider-box').each(function(i, item){
                    $(item).css('opacity', 1).addClass('animated slideInUp');
                });
                $('.Custom-Slider-form').css('opacity', 1).addClass('animated slideInUp');
            }, 4000);
            this.$store.watch( (state)=> {return this.$store.getters.config; }, (val) => {
                self.header_services = val.header_services
            });
        },
        mounted : function(){
            let self = this;
            let config = this.$store.getters.config;
            if( !_.isNull(config) )
            {
                self.header_services = config.header_services;
            }
            $("#text_rotating").Morphext({
                animation: "fadeInDown",
                separator: ",",
                speed: 5000,
                complete: function () {}
            });
        },
        methods : {
            tr : function(t){
                return this.translate( this.$language, t);
            },
        },
        computed : {
            currentLanguage : function(){
                return this.$language;
            }
        }
    }
</script>

<style lang="scss">
    $yellow : #4a843e;
    $gray : #f2f2f4;
    $white : white;
    $black : black;
    $gray_strong : #8f99ac;
    .Custom-Slider
    {
        margin-top: 0px;
        margin-bottom: 0px;
        height: 800px;
        overflow: hidden;
        background-image: url("../../../assets/images/background.jpg");
        background-size: contain;
        color: $black;
        padding-top: 13.5em;
        position: relative;
        color: $white;
        .row
        {
            z-index: 10;
        }
        &-title
        {
            font-weight: 700;
            font-family: Raleway, sans-serif;
            visibility: inherit;
            transition: none;
            text-align: inherit;
            line-height: 40px;
            border-width: 0px;
            margin: 0px;
            padding: 0px;
            letter-spacing: 0px;
            font-size: 40px;
            white-space: nowrap;
            min-height: 0px;
            min-width: 0px;
            max-height: none;
            max-width: none;
            opacity: 0;
            z-index: 5;
            color: white;
            transition: all 1s ease;
        }
        &-rating
        {
            margin-top: 1.5em;
            z-index: 5;
            color: white;
            ul
            {
                list-style: none;
                li
                {
                    display: inline-block;
                    opacity: 0;
                    transition: all 1s ease;
                }
            }
            &-text
            {
                font-family: 'Lato', sans-serif;
                visibility: visible;
                transition: none;
                text-align: inherit;
                line-height: 30px;
                border-width: 0px;
                margin: 0px;
                padding: 0px;
                letter-spacing: 0px;
                font-weight: 400;
                font-size: 30px;
                white-space: nowrap;
                min-height: 0px;
                min-width: 0px;
                max-height: none;
                max-width: none;
                opacity: 1;
                transform: matrix(1, 0, 0, 1, 0, 0);
            }
        }
        &-list
        {
            font-family: 'Lato', sans-serif;
            z-index: 5;
            color: white;
            ul
            {
                list-style: none;
                margin-top: 2em;
                li
                {
                    visibility: visible;
                    transition: none;
                    text-align: inherit;
                    line-height: 20px;
                    border-width: 0px;
                    margin: 0px;
                    padding: 0px;
                    letter-spacing: 1px;
                    font-weight: 600;
                    font-size: 20px;
                    white-space: nowrap;
                    min-height: 0px;
                    min-width: 0px;
                    max-height: none;
                    max-width: none;
                    opacity: 0;
                    margin-bottom: 1.5em;
                    transition: all 1s ease;
                }
            }
        }
        &-box
        {
            background-color: $gray;
            color: $gray_strong;
            height: 40px;
            box-sizing: border-box;
            margin-top: 7em;
            opacity: 0;
            transition: all 1s ease;
            &-item
            {
                &-icon
                {
                    background-color: $yellow;
                    text-align: center;
                    vertical-align: middle;
                    height: 40px;
                    color: white;
                    font-size: 1.2em;
                    padding-top: 8px;
                    padding-left: 13px;
                    &.flat
                    {
                        padding: 0;
                        i
                        {
                            position: relative;
                            left: -9px;
                            top: 6px;
                        }
                    }
                }
            }
        }
        &-form
        {
            opacity: 0;
            transition: 1s all ease;
        }
    }
</style>
<style lang="css">
    .Custom-Slider:before
    {
        width: 100%;
        height: 100%;
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        pointer-events: none;
        background: rgba(147, 0, 17, .75);
        background: -webkit-gradient(left top, right bottom, color-stop(0, rgba(135, 183, 125, .5)), color-stop(100%, rgba(74, 132, 62, .5)));
        background: -webkit-linear-gradient(145deg, rgba(135, 183, 125, .5) 0, rgba(74, 132, 62, .5) 100%);
        background: -webkit-linear-gradient(315deg, rgba(135, 183, 125, .5) 0, rgba(74, 132, 62, .5) 100%);
        background: linear-gradient(135deg, rgba(135, 183, 125, .5) 0, rgba(74, 132, 62, .5) 100%);
        filter: progid: DXImageTransform.Microsoft.gradient( startColorstr='#87b77d', endColorstr='#4a833e', GradientType=1);
        z-index: 0;
    }
</style>


// WEBPACK FOOTER //
// CustomSlider.vue?7f9961ec